// extracted by mini-css-extract-plugin
export default {"details":"simple-accordion_details__w21eE"};